export default [
    {
        fileName: "beneficiary/uponline-multibeneficii.png",
        link: "https://open-upplus.netlify.app/",
        category: "Banner",
        action: "Click",
        label: "Beneficiary_UpMobil_ShutDown",
    },
    //push
];
